import {Component} from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { ResizeDetectionService } from '../../services/resize-detection.service';
import { MealModel } from '../../models/home/meal-model';
import { Router, ActivatedRoute } from '@angular/router';
import { PlanService } from '../../services/plan/plan.service';
import { Carousel } from 'primeng/carousel';
import { trigger, transition, style, animate } from '@angular/animations';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss', './home-mobile.component.scss', './home-tablet.component.scss'],
    animations: [
        trigger('fade', [
            transition('void => *', [
                style({ opacity: 0 }),
                animate(500, style({opacity: 1}))
            ])
        ])
    ]
})
export class HomeComponent {
    chefs: any[] = [];
    experts: any[] = [];
    masterPlanData: any[] = [];
    selectedMasterTab: number | null = 0;
    mealsModel: MealModel[] = [];
    filteredMasterPlan: MealModel[] = [];
    comments: any = [];
    responsiveOptions: any[] = [];
    isTablet: boolean = false;
    isMobile: boolean = false;
    isDesktop: boolean = false;

    cookiePopupVisibility: boolean = false;
    customCookiePopupVisibility: boolean = false;

    widthMeal: number = 0;
    heightMeal: number = 0;

    

    images_slider = [
        { imgSrc: 'assets/images/athletes/adam-moussa.jpg', name: 'Adam Moussa', title: 'IFBBPro Classic Physique', description: 'Nutrigenic elevates our entire programme, ensuring every athlete is fuelled for success' },
        { imgSrc: 'assets/images/athletes/chayanne-evans-gray.jpg', name: 'Chayanne Evans Gray', title: 'Team GB – Track Athelete', description: 'With Nutrigenic, I’m lighter on my feet and sharper in my sprints—pure performance, no compromise' },
        { imgSrc: 'assets/images/athletes/farid-basharat.jpg', name: 'Farid Basharat', title: 'UFC Fighter', description: 'Nutrigenic gives me the edge I need—clean, powerful fuel that keeps me going strong in the cage.' },
        { imgSrc: 'assets/images/athletes/jason-long.jpg', name: 'Jason Long', title: 'Pro Athlete’s Coach', description: 'My athletes trust Nutrigenic for a reason: it’s reliable, nutritious, and consistently elevates their game.' },
        { imgSrc: 'assets/images/athletes/lily-ella-dolling.jpg', name: 'Lily Ella Dolling', title: 'Boxing English Champion', description: 'Nutrigenic fuels my training camp with balanced nutrition—I stay strong and focused round after round.' },
        { imgSrc: 'assets/images/athletes/marky-james.jpg', name: 'Marky James', title: 'IFBBPro Classic Physique', description: 'Consistent quality meals mean I can bulk, cut, or maintain shape with absolute confidence.' },
        { imgSrc: 'assets/images/athletes/yaser-al-ghena.jpg', name: 'Yaser Al Ghena', title: 'Boxing English Champion', description: 'Nutrigenic keeps me sharp, powerful, and ready to strike—real fuel for every fight.' },
    ];

    images_loghi = [
        { imgSrc: 'assets/images/loghi/daily-mail.svg', name: 'Daily Mail' },
        { imgSrc: 'assets/images/loghi/womenshealth.svg', name: 'Women\'s Health' },
        { imgSrc: 'assets/images/loghi/mail-online.svg', name: 'Mail Online' },
        { imgSrc: 'assets/images/loghi/metro.svg', name: 'Metro' },
        { imgSrc: 'assets/images/loghi/the-guardian.svg', name: 'The Guardian' },
        { imgSrc: 'assets/images/loghi/menshealth.svg', name: 'Men\'s Health' },
        { imgSrc: 'assets/images/loghi/the-times-and-the-sunday-times.svg', name: 'The times and the sunday times' }
    ];
    constructor(
        private sizedetection: ResizeDetectionService,
        private planService: PlanService,
        private router: Router,
        private route: ActivatedRoute,
    ) {
        Carousel.prototype.onTouchMove = () => { };
    }

   


    ngOnInit() {
        this.sizedetection.refreshSize();
        this.sizedetection.sizeCondition$.subscribe(data => {
            this.isDesktop = data.isDesktop;
            this.isTablet = data.isTablet;
            this.isMobile = data.isMobile;
            if (!this.isMobile) {
                this.widthMeal = 180;
                this.heightMeal = 180;
            } else {
                this.widthMeal = 313;
                this.heightMeal = 313;
            }
        });

        this.getMeals({ tag_id: 4, page: 1, length: 8 });

        if (localStorage.getItem('cookie')) {
            this.cookiePopupVisibility = false;
        } else this.cookiePopupVisibility = true;
    }


    acceptCookie() {
        localStorage.setItem('cookie', "1");
        this.cookiePopupVisibility = false;
    }
    customizeCookie() {
        this.cookiePopupVisibility = false;
        this.customCookiePopupVisibility = true;
    }
    rejectCookie() {
        this.cookiePopupVisibility = false;
    }
    acceptCookieOpen() {
        localStorage.setItem('cookie', "1");
        this.customCookiePopupVisibility= false;
    }
    customizeCookieOpen() {
        localStorage.setItem('cookie', "1");
        this.customCookiePopupVisibility = false;
    }
    rejectCookieOpen() {
        this.customCookiePopupVisibility = false;
    }

    loadMore() {
        this.getMeals({ tag_id: this.selectedMasterTab, page: ++this.paginator.page, length: 8 }, this.selectedMasterTab || 4);
    }

    paginator: any = {
        page: 1,
        total: 0,
        last_page: 1
    };

    getMeals(query: any, id: number = 4) {
        //this.mealsModel = [];
        lastValueFrom(this.planService.getMealsHome(query))
            .then((response: any) => {
                //console.log(response);
                this.paginator.page = response.body.current_page;
                this.paginator.total = response.body.total;
                this.paginator.last_page = response.body.last_page;
                response.body.data.forEach((item: any) => {
                    var mealModel = new MealModel();
                    mealModel.id = item.id;
                    mealModel.name = item.name;
                    mealModel.description = item.description;
                    mealModel.type = item.type;
                    mealModel.is_master_meal = item.is_master_meal;
                    mealModel.photo_path = item.photo_path;
                    mealModel.energyKcal = parseInt(item.energyKcal);
                    mealModel.protein = parseInt(item.protein);
                    mealModel.fat = parseInt(item.fat);
                    mealModel.availableCarbohydrate = parseInt(item.availableCarbohydrate);
                    mealModel.sugars = parseInt(item.sugars);
                    mealModel.sodium = parseInt(item.sodium);
                    mealModel.categoryId = item.categories.id;
                    mealModel.categoryKey = item.categories.key_name;
                    mealModel.categoryName = item.categories.name;
                    mealModel.salt = parseInt(item.salt);
                    mealModel.is_hover = false;
                    this.filteredMasterPlan.push(mealModel);
                });
                if (id!=9 && id!=3) {
                    this.array_move(this.filteredMasterPlan, 2, 7);
                    this.array_move(this.filteredMasterPlan, 1, 0);
                    //this.array_move(this.filteredMasterPlan, 7, 0);
                    //this.array_move(this.filteredMasterPlan, 1, 7);
                } else if (id==3) {
                    this.array_move(this.filteredMasterPlan, 1, 0);
                }
                this.selectedMasterTab = id;
            })
    }

    items: any = [
        { num: 1, is_hover: true },
        { num: 2, is_hover: true },
        { num: 3, is_hover: true },
        { num: 4, is_hover: true },
        { num: 5, is_hover: true },
        { num: 6, is_hover: true },
        { num: 7, is_hover: true },
        { num: 8, is_hover: true },
    ]
    isHover(num: number) {
        return this.items.filter((x: any) => x.num == num)[0].is_hover;
    }
    mouseEnter(num: number) {
        this.items.filter((x: any) => x.num != num).forEach((element: any) => {
            element.is_hover = false;
        });
    }
    mouseLeave() {
        this.items.forEach((element: any) => {
            element.is_hover = true;
        });
    }

    goToPlan() {
        this.router.navigate(["order-flow"]);
    }

    goToHelp() {
        window.scrollTo(0, document.body.scrollHeight);
    }

    

    array_move(arr:any, old_index:number, new_index:number) {
        if (new_index >= arr.length) {
            var k = new_index - arr.length + 1;
            while (k--) {
                arr.push(undefined);
            }
        }
        arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
        //return arr; // for testing
    };




}
